import "./styles/index.css";

import { Header } from "./sections/Header";
import { Hero } from "./sections/Hero";
import { Experience } from "./sections/Experience";
import { Skills } from "./sections/Skills";
import { Contact } from "./sections/Contact";
import { Footer } from "./sections/Footer";
import { AxenPopout } from "./sections/AxenPopout";

export function App() {
  return (
    <div className="bg-surface-page text-text-primary font-body min-h-screen">
      <Header />
      <main>
        <Hero />
        {/* The hairline that separates the hero plate from the work band. */}
        <div className="h-px bg-border-hairline mx-gutter" />
        <Experience />
        <Skills />
        <Contact />
      </main>
      <Footer />
      <AxenPopout />
    </div>
  );
}

export default App;
